// extracted by mini-css-extract-plugin
export default {"btn":"macros_btn__Cfk0b","header":"macros_header__-ngh5","title":"macros_title__pTgy5","container-overflow":"macros_container-overflow__5mLR3"};